/* Inventory is a Shopify render snapshot. This script never changes inventory. */
(function () {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-lfp-trust]').forEach(function (card) {
      if (card.dataset.lfpInventoryReady) return;
      card.dataset.lfpInventoryReady = '1';
      var data = card.querySelector('[data-lfp-inv]');
      var row = card.querySelector('[data-lfp-stock-row]');
      var stockMessage = card.querySelector('[data-lfp-stock-message]');
      var demandMessage = card.querySelector('[data-lfp-demand-message]');
      var form = card.closest('form');
      if (!data || !row || !form) return;
      var inventory;
      try { inventory = JSON.parse(data.textContent); } catch (e) { inventory = {}; }
      function paint(id) {
        var v = inventory[String(id)];
        var reliable = !!v && v.m && Number.isInteger(v.q) && v.q > 0;
        row.hidden = !reliable;
        if (stockMessage) stockMessage.hidden = !reliable;
        if (demandMessage) demandMessage.hidden = reliable;
        row.querySelector('[data-lfp-stock-num]').textContent = reliable ? String(v.q) : '';
      }
      function selected() {
        var input = form.querySelector('[name="id"]:not([disabled])') || form.querySelector('[name="id"]');
        var id = input && input.value;
        paint(id);
      }
      var section = form.closest('[data-section-type="product"]') || form.closest('.shopify-section') || form;
      function variantChanged(event) {
        var detail = event.detail;
        paint(detail && detail.variant ? detail.variant.id : null);
      }
      section.addEventListener('variantChange', variantChanged);
      section.addEventListener('variant:change', variantChanged);
      form.addEventListener('change', function (event) {
        if (event.target && event.target.name === 'id') selected();
      });
      selected();
    });
    /* Remove only the known duplicated logistics paragraphs from rendered HTML.
       Catalog descriptions, size guidance, policies and app widgets stay intact. */
    var duplicates = [
      'envío gratis en españa en pedidos de 100 € o más',
      'cambios y devoluciones sin costo',
      'cambios y devoluciones sin coste',
      'pago 100 % seguro · tarjeta, bizum, paypal y apple pay'
    ];
    function normalized(text) { return text.replace(/\s+/g, ' ').trim().toLowerCase(); }
    scope.querySelectorAll('.product-single__description').forEach(function (description) {
      description.querySelectorAll('.ms-trust, .lfp-trust, .lff-trust').forEach(function (legacy) {
        if (legacy.matches('[data-lfp-trust]') || legacy.querySelector('img, video, iframe, input, button')) return;
        var rows = Array.from(legacy.querySelectorAll('p, li'));
        var matches = rows.filter(function (row) { return duplicates.indexOf(normalized(row.innerText || row.textContent)) !== -1; });
        var onlyLogistics = rows.every(function (row) {
          var text = normalized(row.innerText || row.textContent);
          return duplicates.indexOf(text) !== -1 || text.indexOf('¿dudas con la talla?') === 0 || text.indexOf('plazos según disponibilidad') === 0;
        });
        if (matches.length < 2 || !onlyLogistics) return;
        rows.filter(function (row) { return normalized(row.textContent).indexOf('¿dudas con la talla?') === 0; }).forEach(function (guide) { legacy.before(guide); });
        legacy.hidden = true;
        legacy.setAttribute('data-lfp-duplicate-trust', '');
      });
      description.querySelectorAll('p, li, div').forEach(function (node) {
        if (node.querySelector('img, video, iframe, input, button')) return;
        var text = normalized(node.innerText || node.textContent);
        if (duplicates.indexOf(text) !== -1) {
          node.hidden = true;
          node.setAttribute('data-lfp-duplicate-trust', '');
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
